<script setup lang="ts">
import PartTitleHead from '@parts/part-title-head.vue';
import PartCounterList from '@parts/part-counter-list.vue';
import { useSettings } from '@composables/settings';

const {
	groupName,
	currentGroup,
	maxActiveIndex
} = useSettings();

const props = defineProps({
	fields: {
		type: Object,
		default: () => ({})
	}
});
</script>

<template>
	<section class="section-settings">
		<div class="section-settings__head">
			<div class="wrapper">
				<part-title-head
					v-if="currentGroup?.title || currentGroup?.subtitle"
					icon="/images/settings-icon.svg"
					:title="currentGroup?.title ? $t(currentGroup?.title) : null"
					:subtitle="currentGroup?.subtitle ? $t(currentGroup?.subtitle) : null"
					class="section-settings__content"
				></part-title-head>
				<part-counter-list
					v-if="currentGroup?.list.length > 1"
					:group="groupName"
					:list="currentGroup.list"
					:available-index="maxActiveIndex"
					class="section-settings__list"
				>
				</part-counter-list>
			</div>
		</div>
		<div class="section-settings__body wrapper">
			<slot />
		</div>
	</section>
</template>

<style lang="scss">
.section-settings {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	margin-bottom: calc(-1 * var(--navigation-bar-height) - 1rem);

	&__content {
		margin-bottom: 1.2rem;
		@include min-desktop {
			margin-bottom: 3.2rem;
		}
	}

	&__head {
		flex: 0 0 auto;
	}

	&__list {
		padding-bottom: 2.4rem;
		border-bottom: 1px solid rgba(var(--color-text-rgb), 0.12);
		@include min-desktop {
			padding-bottom: 3.2rem;
		}
	}

	&__body {
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;
		padding-top: 2.4rem;
		padding-bottom: 9.1rem;
		@include min-desktop {
			padding-bottom: 0;
			padding-top: 3.2rem;
			.part-title-head {
				&__title {
					@include font-24-pro-bold;
					--title-gap: 1.2rem;
				}
			}
		}
	}
}
</style>
